export default __webpack_public_path__ + "static/media/TEMPLATE-ANIVERSARIO.87db980d.png";